import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-15" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = {
  style: {"width":"160px"},
  class: "mx-2"
}
const _hoisted_4 = {
  key: 0,
  class: "my-4"
}
const _hoisted_5 = {
  key: 1,
  class: "my-2"
}
const _hoisted_6 = { class: "d-flex justify-end align-center" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = { class: "text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, {
        value: _ctx.$t('growthRecord.listTitle')
      }, null, 8, ["value"]),
      _createVNode(_component_v_spacer),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_text_field, {
          "hide-details": "",
          density: "compact",
          variant: "outlined",
          type: "number",
          modelValue: _ctx.year,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.year) = $event)),
          modelModifiers: { number: true },
          suffix: _ctx.$t('growthRecord.fiscalYearSuffix'),
          color: "primary"
        }, null, 8, ["modelValue", "suffix"])
      ]),
      _createVNode(_component_v_checkbox, {
        modelValue: _ctx.showQuitChildren,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showQuitChildren) = $event)),
        label: _ctx.$t('growthRecord.showQuitChildren'),
        "hide-details": "",
        color: "primary"
      }, null, 8, ["modelValue", "label"])
    ]),
    (_ctx.showDownloadMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_v_alert, {
            variant: "tonal",
            type: "success"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('growthRecord.exportStarted')), 1),
              _createElementVNode("p", null, [
                _createVNode(_component_i18n_t, {
                  keypath: "growthRecord.checkDownloadPage",
                  tag: "span"
                }, {
                  link: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/download/list" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('growthRecord.downloadPage')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.isFetching)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_v_progress_linear, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_v_expansion_panels, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classesWithRecords, (c) => {
            return (_openBlock(), _createBlock(_component_v_expansion_panel, {
              key: c.classObj.classId,
              class: "my-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel_title, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(c.classObj.className), 1),
                    _createVNode(_component_v_spacer),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        rounded: "",
                        variant: "outlined",
                        class: "mr-4",
                        size: "small",
                        onClick: _withModifiers(($event: any) => (_ctx.exportRecords(c.classObj)), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('common.export')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        rounded: "",
                        variant: "flat",
                        size: "small",
                        to: `/growth-record/class/${c.classObj.classId}`,
                        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('growthRecord.goToClassRecord')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_expansion_panel_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_table, null, {
                        default: _withCtx(() => [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('growthRecord.childName')), 1),
                              _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('common.gender')), 1),
                              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('common.age')), 1),
                              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('growthRecord.quitDate')), 1),
                              _cache[3] || (_cache[3] = _createElementVNode("th", { class: "text-left" }, null, -1))
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.records, (record) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: record.child.childId
                              }, [
                                _createElementVNode("td", null, _toDisplayString(record.child.lastName) + " " + _toDisplayString(record.child.firstName), 1),
                                _createElementVNode("td", null, _toDisplayString(record.child.gender === 'male' ? _ctx.$t('common.male') : _ctx.$t('common.female')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.formatAge(record.child.dateOfBirth)), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.formatQuitDate(record.child.quitDate)), 1),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_v_btn, {
                                    color: "primary",
                                    rounded: "",
                                    variant: "outlined",
                                    size: "small",
                                    to: `/growth-record/child/${record.child.childId}`
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('growthRecord.goToChildRecord')), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["to"])
                                ])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}